import { render, staticRenderFns } from "./create-review.vue?vue&type=template&id=05796be0&"
import script from "./create-review.vue?vue&type=script&lang=js&"
export * from "./create-review.vue?vue&type=script&lang=js&"
import style0 from "./create-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports